import { useForm } from "../../hooks/useForm";
import Section from "../layout/Section";
import InfoTooltip from "../layout/InfoTooltip";
import MaterialsTextarea from "./MaterialsTextarea";

export default function WindAnchoringSection() {
  const { hasWindSpeed, windSpeed, isAnchored, setWindSpeed, setAnchored } =
    useForm();

  const sectionTooltip = (
    <>
      Here you must specify if your structure will be subject to special wind
      resistance requirements or if it will be anchored to the ground and if it
      applies to your requirements, sometimes this information is not necessary.
      Both data are key to generate a plan approved by the city or HOA.
    </>
  );

  return (
    <Section
      title="Wind, Anchoring and Material Information"
      tooltip={sectionTooltip}
    >
      <div className="flex flex-col gap-4 md:flex-row items-start mt-6 mb-3">
        <div className="flex flex-col w-full md:w-1/2 md:border-r md:border-gray-600 md:pr-4">
          <span className="text-md mt-2 mb-2">
            Wind speed (mph)
            <InfoTooltip>
              Select "Yes" if you know the wind speed required by your county.
              Then, enter the exact value (for example, "90 mph"). This
              guarantees the structure complies with building codes in hurricane
              or strong wind zones.
            </InfoTooltip>
          </span>
          <p className="text-center">
            Yes
            <input
              type="radio"
              name="mph"
              checked={hasWindSpeed === true}
              onChange={() => setWindSpeed(true, windSpeed)}
              className="mr-3 ml-1"
            />
            No
            <input
              type="radio"
              name="mph"
              checked={hasWindSpeed === false}
              onChange={() => setWindSpeed(false, "")}
              className="mr-3 ml-1"
            />
          </p>
          {hasWindSpeed && (
            <div className="mt-2">
              <input
                type="text"
                value={windSpeed}
                onChange={(e) => setWindSpeed(true, e.target.value)}
                placeholder="Example: 90 mph"
                className="border border-gray-300 rounded px-2 py-1 w-full md:w-2/5"
              />
            </div>
          )}
        </div>

        <div className="flex flex-col w-full md:w-1/2 md:pl-4">
          <span className="text-md mt-2 mb-2">
            Anchored
            <InfoTooltip>
              Select "Yes" if the structure will be anchored to the ground (with
              screws, concrete, etc.).
            </InfoTooltip>
          </span>
          <p className="text-center">
            Yes
            <input
              type="radio"
              name="anchored"
              checked={isAnchored === true}
              onChange={() => setAnchored(true)}
              className="mr-3 ml-1"
            />
            No
            <input
              type="radio"
              name="anchored"
              checked={isAnchored === false}
              onChange={() => setAnchored(false)}
              className="mr-3 ml-1"
            />
          </p>
        </div>
      </div>

      <MaterialsTextarea />
    </Section>
  );
}
